import auth, {
  actionCreators as authActionCreators,
  actions as authActions
} from './auth/authSaga'
import registration, {
  actionCreators as registrationActionCreators,
  actions as registrationActions
} from './registration/registrationSaga'
import legalDocs, {
  actionCreators as legalDocsActionCreators,
  actions as legalDocsActions
} from './legalDocs/legalDocsSaga'
import districtSchool, {
  actionCreators as districtSchoolActionCreators,
  actions as districtSchoolActions
} from './districtSchool/districtSchoolSaga'

import resetPw, {
  actionCreators as resetPwActionCreators,
  actions as resetPwActions
} from './resetPw/resetPwSaga'
import gradPlanner, {
  actionCreators as gradPlannerActionCreators,
  actions as gradPlannerActions
} from './gradPlanner/gradPlannerSaga'
import savePlanSaga, {
  actionCreators as savePlanActionCreators,
  actions as savePlanActions
} from './savePlan/savePlanSaga.js'
import shortUrlSaga, {
  actionCreators as shortUrlActionCreators,
  actions as shortUrlActions
} from './shortUrl/shortUrlSaga.js'
export const actions = {
  authActions,
  registrationActions,
  districtSchoolActions,
  resetPwActions,
  legalDocsActions,
  gradPlannerActions,
  savePlanActions,
  shortUrlActions
}
export const actionCreators = {
  authActionCreators,
  registrationActionCreators,
  districtSchoolActionCreators,
  resetPwActionCreators,
  legalDocsActionCreators,
  gradPlannerActionCreators,
  savePlanActionCreators,
  shortUrlActionCreators
}
export default function * rootSaga () {
  yield [
    auth(),
    registration(),
    districtSchool(),
    resetPw(),
    legalDocs(),
    gradPlanner(),
    savePlanSaga(),
    shortUrlSaga()
  ]
}



// WEBPACK FOOTER //
// ./src/redux/sagas/index.js